import { type CanvasElementDefinition } from '../../canvas-elements/element-definition';

import { getDefaults, getInitial, getIoConfig, getPropsConfig } from './_base-chart.element';
import { BarChartElementHandler } from './ai/bar-chart.element-handler';
import { BarChartDefinitionMapper } from './ai/chart.definition-mapper';
import { ChartComponent } from './chart.component';
import { CHART_DIMENSIONS } from './chart.models';
import { ChartPropsBuilder } from './chart.props-builder';
import { ChartPropsExtractor } from './chart.props-extractor';
import { chartV2Migration } from './migrations/002-all-chart-types.migration';
import { chartV3Migration } from './migrations/003-chart.migration';

export function getBarChartDefinition(): CanvasElementDefinition<'chartBar'> {
  return {
    type: 'chartBar',
    componentType: ChartComponent<'chartBar'>,
    isListed: true,
    name: 'Bar Chart',
    width: { mode: 'value', value: CHART_DIMENSIONS.width, fixed: true },
    height: { mode: 'value', value: CHART_DIMENSIONS.height, fixed: true },
    ioConfig: getIoConfig(),
    propsConfig: getPropsConfig('chartBar'),
    propsBuilder: ChartPropsBuilder,
    propsExtractor: ChartPropsExtractor,
    defaults: getDefaults('Bar Chart'),
    initial: getInitial(),
    groups: ['charts'],
    styleIncludePaths: [
      'style',
      'content.font.fontFamily',
      'content.font.style',
      'content.font.fontSize',
      'content.title.iconPosition',
    ],
    features: {
      ai: {
        showAiPromptAutomatically: true,
        description: true,
      },
      visualStyle: 'block',
    },
    ai: {
      name: 'chartBar',
      handler: () => BarChartElementHandler,
      definitionMapper: () => BarChartDefinitionMapper,
    },

    version: 3,
    migrations: {
      2: chartV2Migration,
      3: chartV3Migration,
    },
  };
}
